/* eslint-disable react/no-danger */
import React from 'react';
import { iconsSvg } from 'utilsTS/icon';

export const IconProvider: React.FC = () => (
    <div style={{ display: 'none' }} dangerouslySetInnerHTML={{ __html: iconsSvg }} />
);

IconProvider.displayName = 'IconProvider';
